import Parse from "../../../Utilities/parse";

class ChalanItemReturnCalc {
    constructor(getValues, setValue, resetField) {
        this._getValues = getValues
        this._setValue = setValue
        this._resetField = resetField
    }

    // set value
    _valueSet(returnItemsforSet = {}, notSetProperty = "") {
        Object.keys(returnItemsforSet).map(singleReturnItemForSet => {
            if (singleReturnItemForSet != notSetProperty) {
                this._resetField(singleReturnItemForSet)
                this._setValue(singleReturnItemForSet, returnItemsforSet[singleReturnItemForSet])
            }
        })
    }

    // convert to number
    _convertToNum() {
        let convertedFieldProps = {}
        Object.keys(this._getValues()).map(fieldProps => {
            convertedFieldProps[fieldProps] = Parse.toNumber(this._getValues(fieldProps))
        })
        return convertedFieldProps
    }

    // unit to total calc
    _unitToTotalCalc() {
        let fieldValue = {...this._convertToNum()}
        let total_return_qty = Parse.toNumber((fieldValue.return_qty + fieldValue.return_bonus_qty).toFixed(3))
        let return_total_price = Parse.toNumber((fieldValue.unit_return_price * total_return_qty).toFixed(2))
        // return
        return {total_return_qty, return_total_price}
    }

    // total to unit calc
    _totalToUnitCalc() {
        let fieldValue = {...this._convertToNum()}
        let total_return_qty = Parse.toNumber((fieldValue.return_qty + fieldValue.return_bonus_qty).toFixed(3))
        let unit_return_price = Parse.toNumber((fieldValue.return_total_price / total_return_qty).toFixed(2))

        // return
        return {unit_return_price}
    }

    // unit price on chalnge
    unitPriceOnChange() {
        this._valueSet(this._unitToTotalCalc())
    }

    // qty on change
    qtyOnChange() {
        this._valueSet(this._unitToTotalCalc())
    }

    // bonus qty on change
    bonusQtyOnChange() {
        this._valueSet(this._unitToTotalCalc())
    }

    // total return price on change
    totalReturnPriceOnChange() {
        this._valueSet(this._totalToUnitCalc())
    }

}

export default ChalanItemReturnCalc